'use client';

import { CartDropdownButton } from '@/components/sections/builder/elements/header/header/cart-dropdown';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { retrieveCart } from '@/lib/actions/cart/action';
import { ThemeType, useBuilderStore } from '@/stores/builder';
import { HttpTypes } from '@/types';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { shallow } from 'zustand/shallow';

function CartButtonComponent({
  host,
  preview,
  theme,
  parentData,
}: {
  host: string;
  preview: boolean;
  theme: ThemeType;
  parentData?: HeaderElementDataType;
}) {
  const themeBuilder = useBuilderStore((state) => state.theme, shallow);
  const themeLayout = preview ? themeBuilder : theme;

  const { data: carts, isLoading } = useQuery({
    queryKey: ['carts'],
    queryFn: async () => {
      const carts = await retrieveCart(host);
      return carts?.data;
    },
  });

  return (
    <CartDropdownButton
      cart={carts as HttpTypes.StoreCart}
      preview={preview}
      host={host}
      theme={themeLayout}
      content={parentData}
      isLoadingData={isLoading}
    />
  );
}

export default CartButtonComponent;
